import Header from './components/Header.jsx';
import Feed from './components/Feed.jsx';

const App = ()=>{
    return <>
     {/* <Header/> */}
     <Feed/>
    </>
}

export default App;